import React from 'react';
import { useTranslation } from 'react-i18next';

function Process() {
  const { t } = useTranslation('homepage');

  return (
    <>
      <style jsx>{`
        @media (max-width: 768px) {
          .tc-process-style1 {
            padding: 60px 0 !important;
          }
          
          .process-image {
            height: 400px !important;
          }
          
          .process-text-box {
            margin-left: 0 !important;
            margin-top: 0 !important;
            padding: 40px 30px !important;
            margin-bottom: 20px;
          }
          
          .process-headline {
            font-size: 28px !important;
            line-height: 1.2 !important;
          }
          
          .process-description {
            font-size: 14px !important;
            max-width: 100% !important;
          }
          
          .process-button {
            padding: 15px 25px !important;
            font-size: 12px !important;
          }
          
          .process-stats {
            display: none !important;
          }
          
          .process-stat-value {
            font-size: 28px !important;
          }
          
          .process-stat-label {
            font-size: 11px !important;
          }
          
          .process-video-button {
            bottom: 20px !important;
            left: 20px !important;
            padding: 12px 20px !important;
          }
          
          .process-video-icon {
            width: 35px !important;
            height: 35px !important;
            margin-right: 10px !important;
          }
          
          .process-video-text {
            font-size: 12px !important;
          }
        }
        
        @media (max-width: 480px) {
          .tc-process-style1 {
            padding: 40px 0 !important;
          }
          
          .process-image {
            height: 300px !important;
          }
          
          .process-text-box {
            padding: 30px 20px !important;
          }
          
          .process-headline {
            font-size: 22px !important;
          }
          
          .process-description {
            font-size: 13px !important;
          }
          
          .process-button {
            padding: 12px 20px !important;
            font-size: 11px !important;
          }
          
          .process-stats {
            display: none !important;
          }
          
          .process-stat-value {
            font-size: 24px !important;
          }
          
          .process-stat-label {
            font-size: 10px !important;
          }
          
          .process-video-button {
            bottom: 15px !important;
            left: 15px !important;
            padding: 10px 15px !important;
          }
          
          .process-video-icon {
            width: 30px !important;
            height: 30px !important;
            margin-right: 8px !important;
          }
          
          .process-video-text {
            font-size: 11px !important;
          }
        }
      `}</style>
      <section className="tc-process-style1" style={{ 
        backgroundColor: '#ffffff',
        padding: '100px 0'
      }}>
        <div className="container">
        {/* Top Split Layout (Main Hero Content) */}
        <div className="row align-items-center" style={{ minHeight: '600px', position: 'relative' }}>
          {/* Left Column - Full-height Image */}
          <div className="col-lg-6 col-md-12" style={{ padding: '0' }}>
            <div className="process-image" style={{ 
              position: 'relative',
              height: '600px',
              backgroundImage: 'url(/home1/assets/img/projects/proj2.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              borderRadius: '16px'
            }}>
              {/* Play Button & Label */}
            
            </div>
          </div>

          {/* Right Column - Overlapping White Text Box */}
          <div className="col-lg-6 col-md-12" style={{ padding: '0' }}>
            <div className="process-text-box" style={{
              backgroundColor: 'white',
              padding: '60px 50px',
              marginLeft: '-50px',
              marginTop: '50px',
              boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
              borderRadius: '12px',
              position: 'relative',
              zIndex: '2'
            }}>
              {/* Small Intro Label */}
              <span style={{
                fontSize: '12px',
                fontWeight: '600',
                color: '#b79d67',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                marginBottom: '20px',
                display: 'block'
              }}>
                {t('process.welcomeSubtitle')}
              </span>

              {/* Headline */}
              <h2 className="process-headline" style={{
                fontSize: '36px',
                fontWeight: '700',
                color: '#333',
                margin: '0 0 30px 0',
                lineHeight: '1.1',
                letterSpacing: '-1px',
                textTransform: 'uppercase'
              }}>
                {t('process.mainTitle')}<br />
                <span style={{ color: 'rgb(73, 69, 56)' }}>{t('process.highlightTitle')}</span>
              </h2>

              {/* Description Paragraph */}
              <p className="process-description" style={{
                fontSize: '16px',
                color: '#6b6b6b',
                lineHeight: '1.7',
                marginBottom: '40px',
                maxWidth: '450px'
              }}>
                {t('process.description')}
              </p>


              {/* Statistics Below Text */}
              <div className="process-stats" style={{ 
                display: 'flex', 
                gap: '80px',
                marginTop: '40px'
              }}>
                {/* Left Metric */}
                <div style={{ textAlign: 'left' }}>
                  <div className="process-stat-value" style={{
                    fontSize: '36px',
                    fontWeight: '700',
                    color: '#333',
                    marginBottom: '8px',
                    lineHeight: '1',
                    backgroundColor: '#f8f9fa',
                    padding: '15px 20px',
                    borderRadius: '12px',
                    display: 'inline-block',
                    minWidth: '80px',
                    textAlign: 'center'
                  }}>
                    {t('process.stats.experience.value')}
                  </div>
                  <div className="process-stat-label" style={{
                    fontSize: '13px',
                    color: '#666',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    marginTop: '8px',
                    textAlign: 'center'
                  }}>
                    {t('process.stats.experience.label')}
                  </div>
                </div>

                {/* Right Metric */}
                <div style={{ textAlign: 'left' }}>
                  <div className="process-stat-value" style={{
                    fontSize: '36px',
                    fontWeight: '700',
                    color: '#333',
                    marginBottom: '8px',
                    lineHeight: '1',
                    backgroundColor: '#f8f9fa',
                    padding: '15px 20px',
                    borderRadius: '12px',
                    display: 'inline-block',
                    minWidth: '80px',
                    textAlign: 'center'
                  }}>
                    {t('process.stats.projects.value')}
                  </div>
                  <div className="process-stat-label" style={{
                    fontSize: '13px',
                    color: '#666',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    marginTop: '8px',
                    textAlign: 'center'
                  }}>
                    {t('process.stats.projects.label')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </section>
    </>
  );
}

export default Process;
